import { Tooltip, TooltipContent, TooltipTrigger } from '@monksflow/monks-ui';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { ANNOTATION_STROKE_PRESETS } from '../../model/comments.store';

interface Props {
  strokeColor: string;
  onPick: (color: string) => void;
}

export function ColorRow({ strokeColor, onPick }: Props) {
  const { t } = useTranslation('projects');

  return (
    <div className="flex items-center gap-1">
      {ANNOTATION_STROKE_PRESETS.map(({ color, label }) => {
        const isSelected = strokeColor === color;
        return (
          <Tooltip key={color}>
            <TooltipTrigger asChild>
              <button
                type="button"
                aria-label={t('commentOnFile.colorRow.strokeColor', { color: label })}
                aria-pressed={isSelected}
                onClick={() => onPick(color)}
                className={clsx(
                  'flex size-10 items-center justify-center rounded-md transition-colors',
                  isSelected ? 'bg-accent' : 'hover:bg-accent/60',
                )}
              >
                <span className="size-4 rounded-full" style={{ backgroundColor: color }} />
              </button>
            </TooltipTrigger>
            <TooltipContent>{label}</TooltipContent>
          </Tooltip>
        );
      })}
    </div>
  );
}
